import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

export class CommandCreateJob {
  async run(payload: any): Promise<Job> {
    try {
      const response = await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/jobs/`,
        {
          method: "POST",
          body: JSON.stringify(payload),
        }
      );

      // Backend returns the created job object directly, so deserialize it
      return this.deserialize(response);
    } catch (error) {
      console.error("Error creating job:", error);
      throw error;
    }
  }

  private deserialize(data: any): Job {
    const serializer = new JobSerializer();
    return serializer.deserialize(data);
  }
}
